<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Outsourced Sales Report</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <!-- <v-row>
          <v-btn color="accent" small to="/outsourced-sales/create">
            <v-icon left dark>mdi-plus</v-icon>Create Sales
          </v-btn>
        </v-row> -->

        <v-row>
          <!-- datepicker 2 -->
          <v-col cols="12" xs="12" md="4">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  outlined
                  single-line
                  v-model="record.StartDate"
                  label="From"
                  prepend-icon="mdi-calendar-month"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="record.StartDate"
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <!-- datepicker 2 -->
          <v-col cols="12" xs="12" md="4">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  outlined
                  single-line
                  v-model="record.EndDate"
                  label="To"
                  prepend-icon="mdi-calendar-month"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="record.EndDate"
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col ccols="12" xs="12" md="4">
            <v-btn color="primary" @click="queryData" :loading="loader"
              >Query Data</v-btn
            >

            <download-excel
                  :data="sales"
                  :fields="fields"
                  name="Outsourced"
                >
                  <v-icon color="green">mdi-file-excel</v-icon>
                </download-excel>
          </v-col>
        </v-row>

        <v-row>
          <v-text-field
            outlined
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12">
            <span v-if="TotalProfit" style="font-size: 16px; font-weight: bold"
              >Total Profit: {{ TotalProfit.toLocaleString() }}</span
            >
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table
              :items-per-page="pageItems"
              :headers="headers"
              :items="sales"
              :search="search"
              :mobile-breakpoint="0"
            >
              <!-- cost of sales template -->
              <template v-slot:item.CostOfSales="{ item }">
                {{ (item.Quantity * item.BuyingPrice).toLocaleString() }}
              </template>
              <!-- end -->

              <!-- total sales template -->
              <template v-slot:item.TotalSales="{ item }">
                {{ (item.Quantity * item.SellingPrice).toLocaleString() }}
              </template>
              <!-- end -->

              <!-- total sales template -->
              <template v-slot:item.LineProfit="{ item }">
                {{ item.LineProfit.toLocaleString() }}
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn
                  color="editIcon"
                  text
                  :to="`/outsourced-sales/${item.id}`"
                  icon
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "CustomersIndex",
  data: () => ({
    search: "",
    pageItems: 100,
    TotalProfit: null,
    record: {},
    loader: false,
    menu1: false,
    menu2: false,
    headers: [
      { text: "Customer", value: "ocrd.Name" },
      { text: "Product Name", value: "Name" },
      { text: "Quantity", value: "Quantity" },
      { text: "Buying Price", value: "BuyingPrice" },
      { text: "Cost Of Sales", value: "CostOfSales" },
      { text: "Selling Price", value: "SellingPrice" },
      { text: "TotalSales", value: "TotalSales" },
      { text: "Commission", value: "Commission" },
      { text: "Profit", value: "LineProfit" },
      { text: "Date", value: "DocDate" },
      { text: "Action", value: "action" },
    ],
    fields: {
        Product: "Name",
        Quantity: "Quantity",
        BuyingPrice: "BuyingPrice",
        SellingPrice: "SellingPrice",
        Commision: "Commission",
        Profit: "LineProfit",
        Date: "DocDate",
      },
    sales: [],
  }),
  methods: {
    setStartDate(date) {
      this.record.StartDate = date;
    },
    setEndDate(date) {
      this.record.EndDate = date;
    },
    queryData() {
      const data = this.record;
      const url = "/outsourced-reports";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.sales = res.ResponseData.AllSourced;
            self.TotalProfit = res.ResponseData.LineProfit;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getSales() {
      const data = {
        StartDate: new Date().toISOString().substr(0, 10),
        EndDate: new Date().toISOString().substr(0, 10),
      };
      const url = "/outsourced-reports";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.sales = res.ResponseData.AllSourced;
            self.TotalProfit = res.ResponseData.LineProfit;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getSales();
  },
};
</script>